import * as React from 'react';
const ExpandedRowContext = React.createContext(null);
export default ExpandedRowContext;
